import { Link } from 'react-router-dom'
import { SidebarMenuItem } from 'utils/sidebarMenuItems'

interface IMenuItemProps {
  menuItem: SidebarMenuItem
  activedMenu: string
}

const MenuItem = ({ menuItem, activedMenu }: IMenuItemProps) => {
  const { key: headerKey } = menuItem || {}

  return (
    <>
      <li className="nav-item">
        <div className="nav-item-wrapper">
          {menuItem.header && (
            <a
              className="nav-link dropdown-indicator label-1"
              href={`#nv-${headerKey}`}
              role="button"
              data-bs-toggle="collapse"
              aria-expanded="true"
              aria-controls={`nv-${headerKey}`}
            >
              <div className="d-flex align-items-center">
                <div className="dropdown-indicator-icon">
                  <span className="fas fa-caret-right" />
                </div>
                <span className="nav-link-icon">
                  <span data-feather="pie-chart" />
                </span>
                <span className="nav-link-text">{menuItem.header}</span>
              </div>
            </a>
          )}
          <div className="parent-wrapper label-1">
            <ul
              className="nav collapse parent show"
              data-bs-parent="#navbarVerticalCollapse"
              id={`nv-${headerKey}`}
            >
              {menuItem.header && (
                <li className="collapsed-nav-item-title d-none">{headerKey}</li>
              )}
              {menuItem.items ? (
                menuItem.items.map(i => {
                  return (
                    <li key={i.name as string} className="nav-item">
                      <Link
                        className={`nav-link ${
                          activedMenu === i.key ? 'active' : ''
                        }`}
                        to={i.path}
                        data-bs-toggle
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center">
                          <span className="nav-link-text">{i.name}</span>
                        </div>
                      </Link>
                      {/* more inner pages*/}
                    </li>
                  )
                })
              ) : (
                <></>
              )}
            </ul>
          </div>
        </div>
      </li>
    </>
  )
}

export default MenuItem
